export default __webpack_public_path__ + "static/media/3.ad90070a.jpg";